/** @jsxImportSource @emotion/react */
import React from 'react'
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import { useTranslation } from 'react-i18next'
import { ProductTypeStat } from '../orders/models/dashboard-stats.type'
import { CHART_COLORS, formatInt } from './dashboard-helpers'
import { DashboardChartCard } from './dashboard-chart-card'

type Props = {
    data: ProductTypeStat[]
}

export const ProductTypeDonut: React.FC<Props> = ({ data }) => {
    const { t } = useTranslation()
    const chartData = data.map((item) => ({ type: item.type, count: item.count }))

    return (
        <DashboardChartCard
            title={t('TEXT_PRODUCT_TYPE_BREAKDOWN', 'Fordeling per produkttype')}
            isEmpty={chartData.length === 0}
            emptyText={t('TEXT_NO_DATA', 'Ingen data for valgt periode')}
        >
            <ResponsiveContainer width="100%" height={320}>
                <PieChart>
                    <Pie data={chartData} dataKey="count" nameKey="type" innerRadius={60} outerRadius={100} paddingAngle={2}>
                        {chartData.map((entry, index) => (
                            <Cell key={entry.type} fill={CHART_COLORS[index % CHART_COLORS.length]} />
                        ))}
                    </Pie>
                    <Tooltip formatter={(value: number) => formatInt(value)} />
                    <Legend />
                </PieChart>
            </ResponsiveContainer>
        </DashboardChartCard>
    )
}
